module.exports = __webpack_public_path__ + "img/IMG_13201.7d2f75f9.jpg";